module.exports = __webpack_public_path__ + "frontend/img/icon-account.5ec6e329.svg";